import React from 'react';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { volumeMedium, rateCallSvg, assistedTransfer, dtmfSVG, mute, resume, ivr, record, hangUpLeaveMessage, noVolume, volume } from '../../../Images/CallSpaceHeaderSVG';
import { markCallWindow,dtmfTonesWindow,ongoingCallIvrWindow,rateRecordWindow, transferCallWindow } from '../../../js/draggableComponents';
import { insertWindow } from '../../../redux/actions/A_draggable_windows_controller';
import {  HANG_UP_SUBACTIONS } from '../../../constants';
import { messageToStateMachine } from '../../../redux/actions/A_messages_to_SM';
import { messageHangUp, messageStartStopRecording } from '../../../js/helpers/helperMessages';
import VolumeContainer from './VolumeContainer';
import { SingletonSharedData } from '../../../js/singletonSharedData';
import { APIFactory } from 'cw-galatea-api-js/cw-galatea-api-js-bundle';
import { callAction } from '../../../redux/actions/A_reducer_call_acd';
import { ACTION_CALL_ACD } from '../../../constants';
import { Singleton } from '../../../js/Singleton';

const sharedData = new SingletonSharedData();
const  APIFact = new APIFactory();
const apiCont = APIFact.buildClient();
const language = new Singleton();
const markPermissionValue = sharedData.getAllowMarksPermission();

const CallButtons = ({ initialDialogTime,setIsRateInDialog }) => {
    const { selectedRecord:{volume:{speakerVol},callOutId,camId,phoneToCall} } = useSelector(state => state.preview);
	const {selectedRecord, records} = useSelector(state => state.preview);
	const dispatch = useDispatch();
	const [initialTime, setInitialTime] = useState(initialDialogTime);
	const [isMute, setMute]=useState(false);
	const [showExtraBtns,setShowExtraBtns] = useState({});
	const ivrPermission = sharedData.getGeneralPermissions()[117];
	const renderButtons= [
		{
			idButton: 'disposition',
			image: rateCallSvg,
			tooltip: 'Disposition',
			active: false,
			enabledState: true,
			showed: false,
			realSize: 52,
			className: 'buttonSmallCall',
			action: () => handleDisposition(),
			hideAt: 590
		},
		{
			idButton: 'transfer',
			image: assistedTransfer,
			tooltip: 'Transfer',
			active: false,
			enabledState: true,
			showed: true,
			realSize: 52,
			className: 'buttonBigCall',
			action: () => handleTransfer(),
			hideAt: 530
		},
		{
			idButton: 'leaveMessage',
			image: hangUpLeaveMessage,
			tooltip: 'LeaveMessage',
			active: false,
			enabledState: true,
			showed: false,
			realSize: 52,
			className: 'buttonBigCall',
			action: () => handleHangUpAndLeaveMessage(),
			hideAt: 590
		},
		{
			idButton: 'dtmf',
			image: dtmfSVG,
			tooltip: 'DTMF',
			active: false,
			enabledState: true,
			showed: true,
			realSize: 52,
			className: 'buttonBigCall',
			action: () => handleDTMF(),
			hideAt: 450
		},
		{
			idButton: 'volume',
			image: volumeMedium,
			tooltip: 'Volume',
			active: false,
			enabledState: true,
			showed: true,
			realSize: 52,
			className: 'buttonBigCall',
			action: () => handleVolume(),
			hideAt: 0
		},
		{
			idButton: 'mute',
			image: mute,
			tooltip: 'Mute',
			active: false,
			showed: true,
			enabledState: true,
			realSize: 52,
			className: 'buttonBigCall',
			action: () => handleMute(),
			hideAt: 0
		},
		{
			idButton: 'marks',
			image: resume,
			tooltip: 'Mark',
			active: false,
			showed: false,
			enabledState: true,
			realSize: 52,
			className: 'buttonBigCall',
			action: () => handleMarkCall(),
			hideAt: 480
		},
		{
			idButton: 'ivr',
			image: ivr,
			tooltip: 'IVR',
			active: false,
			enabledState: true,
			showed: false,
			realSize: 52,
			className: 'buttonBigCall',
			action: () => handleIVR(),
			hideAt: 600
		},
		{
			idButton: 'record',
			image: record,
			tooltip: 'Record',
			active: false,
			enabledState: true,
			showed: false,
			realSize: 52,
			className: 'buttonBigCall',
			action: () => handlePauseRecord(),
			hideAt: 600
		}
	];
	const [onTransferWindow, setOnTransferWindow] = useState(false);
	const [currentBtns,setCurrentBtns] = useState(renderButtons)	
	
	useEffect(() => {
		getBtnPermissionToShow();
	}, [])
	
	useEffect(() => {
		if(initialDialogTime !== undefined){
			setInitialTime(initialTime);
		}
	}, [initialDialogTime]);

	useEffect(() => {
		let temp = currentBtns.map(function(r){
			if( r.idButton === 'volume' )
			{
				r.image = (speakerVol === 0 ? noVolume : speakerVol < 60 ? volumeMedium : volume);
				return r;
			} 
			return r;
		})
		setCurrentBtns(temp);
	}, [speakerVol])
	
	const  getBtnPermissionToShow=()=> {
			let objectResponse = apiCont.getObjectResponse();
			let objectData = {
			  UserId: sharedData.getParameters().UserID,
			  Id: camId,
			  CallType: 2,
			  CallOutId: callOutId,
			  Phone: phoneToCall
			};

			apiCont.callIcon(objectData, objectResponse);
			objectResponse.onError = (err) => {
			
			};
			objectResponse.onSuccess = function (objResponse) {
			 
			  setShowExtraBtns(objResponse);
			  showBtns(objResponse)
			};
			getRecordingStateButton();
	};
	const showBtns = objectResponse => {
		let temp = currentBtns.map(function(r){
			switch (r.idButton) {
				case 'disposition':
					r.showed = objectResponse.ShowDisposition;
					return r;
				case 'record':
					r.showed = objectResponse.IsStartStopRecording;
					return r;
				case 'ivr':
					r.showed = Boolean(parseInt(ivrPermission, 10));
					return r;
				case 'leaveMessage':
					r.showed = objectResponse.LeaveRecMessage === 1
				default:
					return r;
				}
		})
		setCurrentBtns(temp)
	}
	const getRecordingStateButton = () => {
		let objectResponseRecordCall = apiCont.getObjectResponse();
    	let objectDataRecord = {
        	campId: camId,
        	option: 2 
		};
		apiCont.GetRecordCallPermission(objectDataRecord, objectResponseRecordCall);
		objectResponseRecordCall.onError = err => {
		};
		objectResponseRecordCall.onSuccess = function (objResponse) {
			showBtnMarks(objResponse)
        }
	};
	
	const showBtnMarks = (objResponse) => {
	    markPermissionValue = sharedData.getAllowMarksPermission();
		let temp = currentBtns.map(function(r){
			if( r.idButton === 'marks' )
			{
				r.showed = objResponse !== 3,
				r.className = markPermissionValue ? 'buttonBigCall' : 'buttonDisabled'
				return r;
			} 
			return r
		})
		setCurrentBtns(temp);
	}

	const checkIsActiveButton = idSeleccion => {	
		return currentBtns.filter(r=> r.idButton === idSeleccion)[0].active
	};

	const selectButton = (buttonId, isActive) => {
		let temp = currentBtns.map(function(r){
			if( r.idButton === buttonId )
			{
				(
					r.active = isActive, 
					r.className = (isActive ? r.className += ' selected' : r.className.replace('selected', ''))
				)
				return r
			} 
			return r;
		})
		setCurrentBtns(temp)
	};

	const handleDisposition = (props = null) => {
		selectButton('disposition', !checkIsActiveButton('disposition'));
		setIsRateInDialog(true);
		dispatch(insertWindow(rateRecordWindow(props, initialTime,callOutId,onCloseDispositionWindow),true));
	};

	const onCloseDispositionWindow = () => {
		selectButton('disposition', false);
		setIsRateInDialog(false);
	}

	const handleTransfer = (messageIntegration = "") => {
		let dataCall = {
			CamId: selectedRecord.camId, CallKey: selectedRecord.callKey, 
			Phone: selectedRecord.phoneToCall, Data: "", ExistsCallout: selectedRecord.callOutId, CallMode: 0, integration:false
		  };
		dispatch(insertWindow(transferCallWindow({ dataCall: dataCall, messageIntegration: messageIntegration }), (onTransferWindow ? false : true)));
	};

	const handleDTMF = () => {
		selectButton('dtmf', !checkIsActiveButton('dtmf'));
		let isEdit =  (Object.keys(showExtraBtns).length >0 ) ? showExtraBtns.IsEditDtmf : false;
		let dtmfOptions = (Object.keys(showExtraBtns).length >0 ) ? showExtraBtns.DtmfOptions : [];
		let dtmfWindow = dtmfTonesWindow({ isEditDtmf: isEdit, dtmfOptions: dtmfOptions, digit: null},onCloseHandleDTMF);
		dispatch(insertWindow(dtmfWindow, true));
	};

	const handleIVR = (props=null) => {
		selectButton('ivr', !checkIsActiveButton('ivr'));
		dispatch(insertWindow(ongoingCallIvrWindow(props,onCloseIVR), true));
	};

	const handleMarkCall = (props = null) => {
		if(markPermissionValue)
		{
			selectButton('marks', !checkIsActiveButton('marks'));
			dispatch(insertWindow(markCallWindow(props, initialTime,callOutId,onCloseMarCallkWindow),true));
		}
	};

	const handleHangUpAndLeaveMessage = () => {
		dispatch(messageToStateMachine(messageHangUp(HANG_UP_SUBACTIONS.LEAVE_MESSAGE, callOutId)));
	};

	const handlePauseRecord = () => {
		selectButton('record', !checkIsActiveButton('record'));  
		dispatch(messageToStateMachine(messageStartStopRecording(!checkIsActiveButton('record'),callOutId)));
	};
	
	const handleMute = () => { 
		let temp= !checkIsActiveButton('mute')
		selectButton('mute',temp);
		setMute(temp);
		dispatch(callAction(ACTION_CALL_ACD.MUTE,temp))
	};

	const handleVolume = () => {
		selectButton('volume', !checkIsActiveButton('volume'));
	};
	const onCloseMarCallkWindow = () => {
		selectButton('marks', false);
	}
	const onCloseHandleDTMF = () => {
		selectButton('dtmf', false);
	}
	const onCloseIVR = () => {
		selectButton('ivr', false);
	}
	return (
		<div className='barButtonsCall'>
			<div className='buttonsContainer'>
				{currentBtns.map(
					(item, i) =>
						item.showed &&
						item.enabledState &&
						(item.idButton === 'volume' ? 
						(
							<VolumeContainer item={item} selectButton={selectButton} mute={isMute} checkIsActiveButton={checkIsActiveButton}/>
						) :
						(
							<OverlayTrigger
								key={`tlt-buttonsContainer-${i}`}
								placement='top'
								overlay={
									<Tooltip id={`tooltIpId-tlt-buttonsContainer-${i}`} className='buttonsContainer-tooltip top show'>
										{language.getText(`GUICallSpace${item.tooltip}`)}
									</Tooltip>
								}>
								<div className={item.className} key={'button' + i} onClick={item.action}>
									{item.image}
								</div>
							</OverlayTrigger>
						))
				)}
			</div>
		</div>
	);
};

export default CallButtons;



// WEBPACK FOOTER //
// ./src/components/workSpace/SimultaneosRecsPreview/CallButtons.jsx